export const myActivitiesStateKey = 'myActivities';
export const maCourseStateKey = 'course';
export const maFlowStateKey = 'flow';
export const maContentStateKey = 'content';
export const maCourseProgressStateKey = 'courseProgress';
export const maChallengeStateKey = 'challenge';
export const maChallengeProgressStateKey = 'challengeProgress';
export const maBookingStateKey = 'booking';
export const maBookingChangeStateKey = 'bookingChange';
